// extracted by mini-css-extract-plugin
export default {"Tag":"Tags_Tag__amQTH","Tags":"Tags_Tags__AGDzg"};